import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
export var transparent = '#00000000';
export var NeutralColors;
(function (NeutralColors) {
  NeutralColors["White"] = "#FFFFFF";
  NeutralColors["Ink"] = "#191919";
  NeutralColors["GreyPaper"] = "#F7F7F6";
  NeutralColors["Grey100"] = "#EAEAE9";
  NeutralColors["Grey200"] = "#DCDCDB";
  NeutralColors["Grey300"] = "#CFCFCE";
  NeutralColors["Grey400"] = "#C2C2C1";
  NeutralColors["Grey500"] = "#A0A0A0";
  NeutralColors["Grey600"] = "#7F7F7F";
  NeutralColors["Grey700"] = "#5E5E5E";
  NeutralColors["Grey800"] = "#3D3D3C";
  NeutralColors["Grey900"] = "#191919";
})(NeutralColors || (NeutralColors = {}));
export var UIPalette;
(function (UIPalette) {
  UIPalette["Red25"] = "#FEF9F8";
  UIPalette["Red50"] = "#FFF7F5";
  UIPalette["Red100"] = "#FFEEEA";
  UIPalette["Red200"] = "#FEE1DC";
  UIPalette["Red300"] = "#FDCCC3";
  UIPalette["Red400"] = "#F5ACA1";
  UIPalette["Red500"] = "#F18174";
  UIPalette["Red600"] = "#E36554";
  UIPalette["Red700"] = "#C13B2F";
  UIPalette["Red800"] = "#8D3B34";
  UIPalette["Red900"] = "#7A2F29";
  UIPalette["Red1000"] = "#4E211D";
  UIPalette["Orange25"] = "#FDF9F5";
  UIPalette["Orange50"] = "#FCF7ED";
  UIPalette["Orange100"] = "#FBF1DF";
  UIPalette["Orange200"] = "#F9E8C8";
  UIPalette["Orange300"] = "#F4D39F";
  UIPalette["Orange400"] = "#ECB462";
  UIPalette["Orange500"] = "#DC8F32";
  UIPalette["Orange600"] = "#CB7A2B";
  UIPalette["Orange700"] = "#AE4E09";
  UIPalette["Orange800"] = "#7E462A";
  UIPalette["Orange900"] = "#6A3C24";
  UIPalette["Orange1000"] = "#452A1C";
  UIPalette["Yellow25"] = "#FCFAF4";
  UIPalette["Yellow50"] = "#FBF9E4";
  UIPalette["Yellow100"] = "#FBF7D0";
  UIPalette["Yellow200"] = "#F7EEB0";
  UIPalette["Yellow300"] = "#EDDE7D";
  UIPalette["Yellow400"] = "#E0C32E";
  UIPalette["Yellow500"] = "#C3A21D";
  UIPalette["Yellow600"] = "#A88A15";
  UIPalette["Yellow700"] = "#866609";
  UIPalette["Yellow800"] = "#695320";
  UIPalette["Yellow900"] = "#57461E";
  UIPalette["Yellow1000"] = "#372F15";
  UIPalette["Green25"] = "#F5FBF8";
  UIPalette["Green50"] = "#F2FCF5";
  UIPalette["Green100"] = "#E2F9E9";
  UIPalette["Green200"] = "#C1F1D0";
  UIPalette["Green300"] = "#A8E6BD";
  UIPalette["Green400"] = "#79D29A";
  UIPalette["Green500"] = "#45B574";
  UIPalette["Green600"] = "#3A9C66";
  UIPalette["Green700"] = "#047B48";
  UIPalette["Green800"] = "#1E6243";
  UIPalette["Green900"] = "#1A513A";
  UIPalette["Green1000"] = "#103727";
  UIPalette["Blue25"] = "#F7FBFE";
  UIPalette["Blue50"] = "#F1F9FE";
  UIPalette["Blue100"] = "#E7F4FD";
  UIPalette["Blue200"] = "#D3EBFD";
  UIPalette["Blue300"] = "#B5DDFC";
  UIPalette["Blue400"] = "#8EC4F6";
  UIPalette["Blue500"] = "#5FA6EC";
  UIPalette["Blue600"] = "#3F8FE4";
  UIPalette["Blue700"] = "#2269BF";
  UIPalette["Blue800"] = "#2B5791";
  UIPalette["Blue900"] = "#294A7A";
  UIPalette["Blue1000"] = "#1B3150";
  UIPalette["Purple25"] = "#FCF9FE";
  UIPalette["Purple50"] = "#FBF6FE";
  UIPalette["Purple100"] = "#F8F1FD";
  UIPalette["Purple200"] = "#F3E4FB";
  UIPalette["Purple300"] = "#E6CEF3";
  UIPalette["Purple400"] = "#DAADF0";
  UIPalette["Purple500"] = "#CA85E5";
  UIPalette["Purple600"] = "#BA6DD7";
  UIPalette["Purple700"] = "#9350AA";
  UIPalette["Purple800"] = "#6E487A";
  UIPalette["Purple900"] = "#633A6E";
  UIPalette["Purple1000"] = "#472050";
  UIPalette["Emerald"] = "#026451";
})(UIPalette || (UIPalette = {}));
export var ForegroundColors;
(function (ForegroundColors) {
  ForegroundColors["DefaultWhite"] = "#FFFFFF";
  ForegroundColors["DefaultMinor"] = "#C2C2C1";
  ForegroundColors["DefaultSubtle"] = "#7F7F7F";
  ForegroundColors["DefaultMuted"] = "#5E5E5E";
  ForegroundColors["DefaultDefault"] = "#3D3D3C";
  ForegroundColors["DefaultEmphasis"] = "#191919";
  ForegroundColors["InformativeMuted"] = "#3F8FE4";
  ForegroundColors["InformativeDefault"] = "#2269BF";
  ForegroundColors["InformativeEmphasis"] = "#2B5791";
  ForegroundColors["InformativeContrast"] = "#294A7A";
  ForegroundColors["CriticalMuted"] = "#E36554";
  ForegroundColors["CriticalDefault"] = "#C13B2F";
  ForegroundColors["CriticalEmphasis"] = "#8D3B34";
  ForegroundColors["CriticalContrast"] = "#7A2F29";
  ForegroundColors["CautionMuted"] = "#A88A15";
  ForegroundColors["CautionDefault"] = "#866609";
  ForegroundColors["CautionEmphasis"] = "#695320";
  ForegroundColors["CautionContrast"] = "#57461E";
  ForegroundColors["SuccessMuted"] = "#3A9C66";
  ForegroundColors["SuccessDefault"] = "#047B48";
  ForegroundColors["SuccessEmphasis"] = "#1E6243";
  ForegroundColors["SuccessContrast"] = "#1A513A";
})(ForegroundColors || (ForegroundColors = {}));
export var Colors = _objectSpread(_objectSpread(_objectSpread({}, NeutralColors), UIPalette), ForegroundColors);